<template lang="pug">
  b-container
    h2.text-bold.text-success.text-center ¡Vende más!
    p.text-secondary.text-center.px-5 Sigue nuestos tips para vender más por chat
    b-card.no-shadow
      b-list-group.list-group-flush.mb-0
        b-list-group-item.d-flex
          check-circle-icon.text-success.mr-3.mt-1.icon-lg
          .flex-1
            b-link(:to="{name: 'Affiliation', params: { account_id: $route.params.account_id } }") Configura tu cuenta para recibir pagos con tarjeta
        b-list-group-item.d-flex
          check-circle-icon.text-success.mr-3.mt-1.icon-lg
          .flex-1
            b-link(:to="{name: 'Products', params: { account_id: $route.params.account_id } }") Configura tu primer producto
        b-list-group-item
          .d-flex
            check-circle-icon.text-success.mr-3.mt-1.icon-lg
            .flex-1
              p.text-secondary Comparte el link de tu chatbot con tus posibles clientes
          b-form-row.align-items-center.justify-content-between
            b-col(cols="10")
              p.mb-0.text-primary {{bussines_url}}
            b-col(cols="auto")
              copy-icon.icon-md.pointer.hover-primary#copy-external-id-icon(@click="copy")
              b-tooltip(target="copy-external-id-icon", triggers="focus click blur", ref="copy-tooltip") Copiado
        b-list-group-item.d-flex
          check-circle-icon.text-success.mr-3.icon-lg
          .flex-1
            p.text-secondary Crea una
              b-link.ml-1(href="https://business.facebook.com/", target="blank") página de negocio en Facebook
              span , si ya tienes una conecta tu chatbot en
              b-link.ml-1(:to="{name: 'Settings', params: { account_id: $route.params.account_id } }") Configuración
        b-list-group-item.d-flex
          check-circle-icon.text-success.mr-3.icon-lg
          .flex-1
            p.text-secondary Añade
              b-link.mx-1(href="https://www.google.com.mx/maps", target="blank") tu negocio en google maps
              span y agrega el link de tu chat
          //b-form-row.align-items-center.justify-content-between
            b-col(cols="10")
              p.mb-0.text-primary {{bussines_url}}
            b-col(cols="auto")
              copy-icon.icon-md.pointer.hover-primary#copy-external-id-icon(@click="copy")
</template>

<script>
  const accountController = createNamespacedHelpers('account')
  import { createNamespacedHelpers, mapActions } from 'vuex'

  export default {
    data () {
      return {

      }
    },
    computed: {
      ...accountController.mapState({
        account: state => state.account
      }),
      bussines_url () {
        return `https://${this.account.username}.konverza.me`
      }
    },
    methods: {
      ...mapActions([]),
      copy () {
        let self = this

        var dummy = document.createElement("textarea")
        document.body.appendChild(dummy)
        dummy.value = this.bussines_url
        dummy.select()
        document.execCommand("copy")
        document.body.removeChild(dummy)

        setTimeout(function () {
          self.$refs['copy-tooltip'].$emit('close')
        }, 1000);
      }
    },
    mounted () {

    }
  }
</script>

<style lang="scss" scoped>
  .bg-hover:hover {
    background-color: #e9ecef;
  }
  .flex-1 {
    flex: 1;
  }
</style>
